/* src/app/shared/components/common.modal/common.modal.component.scss */
.ahe-ui-alert-modal .modal-dialog .modal-content {
  padding: 0px;
}
.modal-dialog {
  position: fixed;
  top: 50%;
  z-index: 1010;
  margin: 0px auto;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: visible;
  max-height: calc(100dvh - 48px);
  max-width: 95dvw;
}
.modal-dialog .modal-content {
  overflow: visible;
  max-height: inherit;
}
.modal-dialog.modal-custom-width {
  width: 95dvw;
  max-width: var(--custom-max-width) !important;
}
.header-text {
  color: white;
  margin-top: -3px;
  left: 20px;
  position: absolute;
}
.close {
  opacity: 1;
}
.modal-overlay {
  background-color: rgba(0, 0, 0, 0.2);
}
.modal-footer-new {
  padding-left: 17px !important;
  background-color: #f0f3f4;
  border-top: 1px solid #d1dbde;
}
#common-modal .modal-body,
#common-modal .modal-footer {
  padding-left: 20px !important;
  padding: 30px;
}
#common-modal .modal-footer {
  display: inline-block;
  text-align: left;
}
#common-modal .modal-body {
  overflow-y: auto;
}
.modal-footer-new {
  display: flex;
  align-items: center;
  padding: 1rem;
  border-top: 1px solid #e9ecef;
}
.modal-footer-new button {
  width: 130px;
}
.modal-header-set {
  background-color: #174d5c;
  color: #fff;
  height: 44px;
  padding: 12px 18px 12px 18px;
}
.modal-header-set .close {
  width: 20px;
  height: 20px;
}
.modal-header-set .header-text {
  font-size: 16px;
  font-weight: 400;
  margin-top: 1px;
}
button.close:focus,
button.close:focus-visible,
button.close:focus:not(:focus-visible) {
  outline: auto;
  outline-offset: 0;
  background-color: transparent;
}
button.close:not([disabled]):hover {
  background-color: transparent;
}
@media (max-width: 575px) {
  .modal-overlay {
    display: flex;
    justify-content: center;
    padding: 24px 0;
  }
  .modal-container-new {
    max-width: 95dvw;
    display: flex;
  }
  .modal-dialog-copy {
    width: 100%;
  }
  .modal-content {
    height: 100%;
  }
  .modal-body-copy {
    overflow-x: hidden;
    padding: 16px 12px;
    font-size: 12px;
  }
  .title-div {
    font-size: 14px;
    font-weight: 600;
  }
  .modal-footer-new {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-left: 6px !important;
  }
  #common-modal .modal-body {
    padding: 16px 12px;
    overflow-y: auto;
  }
  .ahe-ui-alert-modal .modal-dialog {
    position: static;
    transform: none;
  }
}
/*# sourceMappingURL=common.modal.component.css.map */
